import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

export class ProdOrderTransitMigrationCommand {
  commandType: ProdOrderTransitMigrationCommandType
}

export enum ProdOrderTransitMigrationCommandType {
  RE_EMIT = 'RE_EMIT',
}

@Injectable({
  providedIn: 'root',
})
export class ProdOrderTransitMigrationService extends RestClientPaged<any, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/migration/prod-order-transit', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public migrate(command: ProdOrderTransitMigrationCommand): Observable<any> {
    return this.http.post<any>(this.restEndpoint, command)
  }
}
